import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ApplicationSettings, reducerKey } from './application-settings.reducer';

export const selectApplicationSettings = createFeatureSelector<ApplicationSettings>(reducerKey);

export const getWifiOnly = createSelector(
  selectApplicationSettings,
  (applicationSettings: ApplicationSettings) => applicationSettings.wifiOnly,
);

export const getSelectedCacheOption = createSelector(
  selectApplicationSettings,
  (appSettings: ApplicationSettings) => appSettings.offlineCacheSizeResponse,
);

export const getCacheOptions = createSelector(
  selectApplicationSettings,
  (applicationSettings: ApplicationSettings) => applicationSettings.cacheOptions || [],
);

export const getLoading = createSelector(
  selectApplicationSettings,
  (applicationSettings: ApplicationSettings) => applicationSettings.loading,
);

export const getOfflineCacheNotification = createSelector(
  selectApplicationSettings,
  (applicationSettings: ApplicationSettings) => applicationSettings.offlineCacheNotificationEnabled,
);

export const getOflfineCahceSize = createSelector(
  selectApplicationSettings,
  (applicationSettings: ApplicationSettings) => applicationSettings.offlineCacheSizeResponse,
);

export const getLoaded = createSelector(
  selectApplicationSettings,
  (applicationSettings: ApplicationSettings) => applicationSettings.loaded,
);

export const getCacheSize = createSelector(
  selectApplicationSettings,
  (applicationSettings: ApplicationSettings) => applicationSettings.cacheSize,
);
